import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { TooltipProvider } from '@/components/ui/tooltip';
import { Toaster as Sonner } from 'sonner';
import { createContext, useState } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppWidget from './components/WhatsAppWidget';
import CalendlyPopup from './components/CalendlyPopup';
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

export const CalendlyContext = createContext<{
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}>({
  isOpen: false,
  setIsOpen: () => {},
});

function App() {
  const [isCalendlyOpen, setIsCalendlyOpen] = useState(false);

  return (
    <CalendlyContext.Provider value={{ isOpen: isCalendlyOpen, setIsOpen: setIsCalendlyOpen }}>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Sonner />
          <Router>
            <div className="min-h-screen flex flex-col">
              <Header />
              <main className="flex-grow">
                <Routes>
                  <Route path="/" element={<Index />} />
                  {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </main>
           
              <WhatsAppWidget />
              <CalendlyPopup />
            </div>
          </Router>
        </TooltipProvider>
      </QueryClientProvider>
    </CalendlyContext.Provider>
  );
}

export default App;
